import './sidebar.scss';

import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import { useNewYearSeason } from 'hooks/useNewYearSeason';
import { canSeeTraderArea } from 'shared/consts/traders';
import { useTypedDispatch, useTypedSelector } from 'store';
import { setIsSidebarOpened } from 'store/slices/ui';
import { isTestnet } from 'web3';

import {
  Accounts,
  CreateNewProject,
  Projects,
  ReportsSideBar,
  WalletsSideBar,
  XnkBotSideBar,
} from './components';

import { DoubleLeftArrowIcon } from 'assets/icons';

const LOGOS = {
  regular: '/images/logo/pg-logo.png',
  regularDev: '/images/logo/pg-logo-dev.png',
  newYear: '/images/logo/pg-logo-ny.png',
  newYearDev: '/images/logo/pg-logo-ny-dev.png',
} as const;

const Sidebar = () => {
  const dispatch = useTypedDispatch();
  const isAdmin = useTypedSelector(store => store.auth.isAdmin);
  const user = useTypedSelector(s => s.auth.user);
  const isSidebarOpened = useTypedSelector(store => store.ui.isSidebarOpened);

  const useNewYear = useNewYearSeason();
  const logoSrc = isTestnet
    ? useNewYear
      ? LOGOS.newYearDev
      : LOGOS.regularDev
    : useNewYear
      ? LOGOS.newYear
      : LOGOS.regular;

  return (
    <aside className={cn('mm-sidebar', { _opened: isSidebarOpened })}>
      <section className={cn('mm-sidebar__header', { _opened: isSidebarOpened })}>
        <NavLink className="mm-sidebar__header__left" to={'/'}>
          <img src={logoSrc} alt="" />
          <h2 className={cn('mm-sidebar__title', { _visible: isSidebarOpened })}>111PG</h2>
        </NavLink>
        <div className={cn('mm-sidebar__header__right', { _collapsed: !isSidebarOpened })}>
          <button
            className={cn('collapse-button', { ghost: !isSidebarOpened })}
            onClick={() => dispatch(setIsSidebarOpened(!isSidebarOpened))}
          >
            <span className={cn('collapse-button__icon', { _collapsed: !isSidebarOpened })}>
              <DoubleLeftArrowIcon />
            </span>
          </button>
        </div>
      </section>
      <div className="mm-sidebar__separator" />
      <section className="mm-sidebar__content">
        <div className="mm-sidebar__menu">
          {isAdmin && <WalletsSideBar />}
          {canSeeTraderArea(user) && <XnkBotSideBar />}
          {isAdmin && <Accounts />}
          {isAdmin && <ReportsSideBar />}
          <Projects />
          {isAdmin && <CreateNewProject />}
        </div>
      </section>
    </aside>
  );
};

export { Sidebar };
